import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import packageService from '../../services/api/packageService';

// Async thunks
export const fetchPackages = createAsyncThunk(
  'packages/fetchPackages',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await packageService.getAllPackages(filters);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPackageById = createAsyncThunk(
  'packages/fetchPackageById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await packageService.getPackageById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchFeaturedPackages = createAsyncThunk(
  'packages/fetchFeaturedPackages',
  async (_, { rejectWithValue }) => {
    try {
      const response = await packageService.getFeaturedPackages();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  packages: [],
  featuredPackages: [],
  currentPackage: null,
  loading: false,
  error: null,
};

const packageSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    clearCurrentPackage: (state) => {
      state.currentPackage = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch packages
      .addCase(fetchPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.packages = action.payload;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch package by ID
      .addCase(fetchPackageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPackage = action.payload;
      })
      .addCase(fetchPackageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch featured packages
      .addCase(fetchFeaturedPackages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFeaturedPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.featuredPackages = action.payload;
      })
      .addCase(fetchFeaturedPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCurrentPackage, clearError } = packageSlice.actions;
export default packageSlice.reducer;

